import { Close } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setActiveWindow, setTaskSelectedItem } from 'app/actions/map';
import { MapTaskInfoList } from 'app/pages/Map';
import React from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
const TASK_STATUS_LABELS = {
    finished: 'Завершено',
    active: 'Активно',
};
const MapTaskWindow = () => {
    const dispatch = useDispatch();
    const { activeWindow, taskSelectedItem } = useSelector((state) => state.map);
    const handleActiveWindow = () => dispatch(setActiveWindow('task'));
    const handleCloseWindowClick = () => dispatch(setTaskSelectedItem(null));
    if (!taskSelectedItem) {
        return React.createElement(React.Fragment, null);
    }
    const statusLabel = TASK_STATUS_LABELS[String(taskSelectedItem.status)];
    return (React.createElement(Draggable, { bounds: 'parent', handle: '.header-draggable' },
        React.createElement(Stack, { direction: 'column', onClick: handleActiveWindow, sx: (theme) => (Object.assign({ position: 'absolute', right: '80px', top: theme.spacing(4), minWidth: '525px', maxWidth: '525px', maxHeight: '630px', zIndex: '1050', overflow: 'hidden', bgcolor: 'background.paper', boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12), borderRadius: theme.shape.borderRadius, transform: 'translate(0px, 0px)', '.header-draggable': {
                    width: '100%',
                    cursor: 'grab',
                    minHeight: '44px',
                    padding: '10px 140px',
                    '.MuiTypography-root': {
                        padding: theme.spacing(0, 2),
                    },
                }, '&.react-draggable-dragging .header-draggable': {
                    cursor: 'grabbing',
                } }, (activeWindow === 'task' && {
                zIndex: '1051',
            }))) },
            React.createElement(Stack, { direction: 'column', sx: {
                    userSelect: 'none',
                    bgcolor: 'background.default',
                    '.MuiTypography-root': {
                        fontSize: '13px',
                    },
                } },
                React.createElement(Stack, { direction: 'row', justifyContent: 'center', alignItems: 'center', className: 'header-draggable' },
                    React.createElement(Typography, { variant: 'h6', component: 'span' },
                        taskSelectedItem.transport_number,
                        "_",
                        moment(taskSelectedItem.task_date).format('DD.MM.YYYY_HH:mm:ss'))),
                React.createElement(Stack, { direction: 'row', alignItems: 'center', component: 'ul', sx: (theme) => ({
                        position: 'absolute',
                        right: '8px',
                        top: '7px',
                        margin: '0',
                        marginLeft: 'auto',
                        listStyle: 'none',
                        li: {
                            margin: '0',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            button: {
                                width: '30px',
                                height: '30px',
                                '.maximizeIcon, .minimizeIcon': {
                                    width: '16px',
                                    height: '16px',
                                },
                            },
                        },
                        'li:not(:last-of-type) path': {
                            fill: theme.palette.text.secondary,
                        },
                    }) },
                    React.createElement("li", null,
                        React.createElement(IconButton, { color: 'default', onClick: handleCloseWindowClick },
                            React.createElement(Close, { fontSize: 'small' }))))),
            React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                    padding: theme.spacing(2),
                }) },
                React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                        display: 'grid',
                        gap: 2,
                        marginBottom: theme.spacing(1),
                        '.MuiPaper-root': {
                            position: 'relative',
                            border: 'none',
                            display: 'grid',
                            gap: '6px',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                        },
                        '.MuiPaper-row': {
                            display: 'grid',
                            gap: 1,
                            gridTemplateColumns: 'repeat(6, 1fr)',
                            '.MuiTypography-root:first-of-type': {
                                color: 'text.secondary',
                            },
                        },
                        '.MuiPaper-row .MuiTypography-root:first-of-type': {
                            gridRow: '1',
                            gridColumn: '1/4',
                        },
                        '.MuiPaper-row .MuiTypography-root:last-of-type': {
                            gridRow: '1',
                            gridColumn: '4/7',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            'span:nth-of-type(2)': {
                                paddingLeft: theme.spacing(0.5),
                            },
                        },
                    }) },
                    React.createElement(Paper, { variant: 'outlined' },
                        React.createElement(Stack, { className: 'MuiPaper-column' },
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u0434\u0430\u043D\u0438\u044F"),
                                React.createElement(Typography, { variant: 'body1' }, taskSelectedItem.id)),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0434\u0430\u043D\u0438\u044F"),
                                React.createElement(Typography, { variant: 'body1' }, statusLabel))),
                        React.createElement(Stack, { className: 'MuiPaper-column' },
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430"),
                                React.createElement(Typography, { variant: 'body1' }, moment(taskSelectedItem.task_date).format('DD.MM.YYYY HH:mm:ss'))),
                            React.createElement(Stack, { className: 'MuiPaper-row' },
                                React.createElement(Typography, { variant: 'body1' }, "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F"),
                                React.createElement(Typography, { variant: 'body1' }, moment(taskSelectedItem.finished_date).isValid() &&
                                    moment(taskSelectedItem.finished_date).format('DD.MM.YYYY HH:mm:ss')))))),
                React.createElement(MapTaskInfoList, null)))));
};
export default MapTaskWindow;
